import firebase from 'firebase/app';
import 'firebase/auth';
import { user } from '../store';
import {push, pop, replace} from 'svelte-spa-router'
import { options } from '../config';

const firebaseConfig = options.firebase;

function getUnixTime() { return new Date().getTime() / 1000 | 0 };

firebase.initializeApp(firebaseConfig);

const auth = firebase.auth();
let red_
export const loginWithEmailPassword = (email, password) =>
    auth.signInWithEmailAndPassword(email, password);

export const loginWithGoogle = () => {
    const provider = new firebase.auth.GoogleAuthProvider();


    return auth.signInWithPopup(provider);

};

export const logout = () => auth.signOut();

// wrap Firebase user in a Svelte readable store

const unsub = auth.onAuthStateChanged(async firebaseUser => {
    if (firebaseUser) {
        const idToken = await firebaseUser.getIdTokenResult(true);

        let { email, displayName, uid } = firebaseUser;
        if(email.endsWith("base2services.com")){
            let d = getUnixTime()+1000
            user.set({ loggedIn: true, email, displayName, uid, expires: d, idToken: idToken.token });
            if(red_){
                replace(red_)
                red_=null
            }

        //   replace(options.home)
        }else{
            logout()
        }
    } else {
        user.set({});
    }
});

export const setRedirect=(path)=>{
    red_=path
}
